import type { TextCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { TextFormField } from "./TextFormField";
import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Strike } from "@tiptap/extension-strike";
import { Underline } from "@tiptap/extension-underline";
import { TextStyle } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import { useRichTextEditor } from "../../rich-text/useRichTextEditor";
import { Language } from "../../rich-text/extension-language";
import { useCreateTextFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TextCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function TextCreationPanel({ fragment, onDelete }: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateTextFromPanelMutation();
  const editor = useRichTextEditor({
    options: {
      extensions: [
        Document,
        Paragraph,
        Text,
        Bold,
        Italic,
        Strike,
        Underline,
        Language,
        TextStyle,
        Color,
      ],
    },
  });

  const onSave = async () => {
    if (!editor) return;
    await createAttribute({
      variables: {
        regionId: fragment.id,
        text: editor.getHTML(),
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("TextCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    >
      <TextFormField fragment={fragment} editor={editor} />
    </AttributePanel>
  );
}
